import CreateHomeworkView from 'views/homeworks/create-homework';

const CreateHomework = () => <CreateHomeworkView />;

export default CreateHomework;
